import React from 'react';
import * as S from './Popup.styles';

type popupProps = {
  title?: string;
  content?: any;
  onCloseClick?:any;
};

const Popup = ({title, content,onCloseClick}: popupProps) => (
  <S.PopupBackground>
    <S.Popup>
      <S.PopupHeader>
        {title}
        <span style={{cursor:'pointer'}} onClick={onCloseClick}>X</span>
      </S.PopupHeader>
      <S.PopupContent>{content}</S.PopupContent>
    </S.Popup>
  </S.PopupBackground>
);

export default Popup;
